import { useEffect } from "react";
import { usePatchPortfolioServicesMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioServicesMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { mapPortfolioToServicesForm } from "web_myplann/Portfolio/Forms/ServicesForm/mapPortfolioToServicesForm";
import { getServicesFormSchema } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormSchema";
import { mapServicesFormToEditRequest } from "web_myplann/Portfolio/Forms/ServicesForm/servicesRequestPayload";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditServicesFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditServicesForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditServicesFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPortfolioServicesMutation(portfolioId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getServicesFormSchema(t, { isCreate: false }),
		defaultValues: mapPortfolioToServicesForm(portfolio),
		mutate: (changedValues, options) =>
			mutate(
				mapServicesFormToEditRequest(changedValues, form.getValues()),
				options,
			),
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
